// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")

require("jquery")       // https://api.jquery.com/
require("js-cookie")    // https://github.com/js-cookie/js-cookie
require("axios")        // https://github.com/axios/axios
require("mustache")     // https://github.com/janl/mustache.js
require("leaflet")      // https://leafletjs.com/reference-1.6.0.html
require("leaflet.markercluster") // https://github.com/Leaflet/Leaflet.markercluster
require("nouislider")   // https://refreshless.com/nouislider/
require("moment")       // https://momentjs.com/docs/
require("moment-timezone") // https://momentjs.com/timezone/

import jquery from 'jquery/src/jquery'
window.jquery = jquery

import './bootstrap_custom.js'
import '../stylesheets/application'

import './custom'

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)
